import { atom } from "jotai";

export const stepAtom = atom(1);